import { z } from "zod";

// Совпадает с CONTRACT_CURRENCIES бэкенда: у контракта бывает только эта
// пара валют, а значит и у банковской строки продавца тоже.
const BANK_ACCOUNT_CURRENCIES = ["USD", "EUR"] as const;

const bankAccountSchema = z.object({
  currency: z.enum(BANK_ACCOUNT_CURRENCIES),
  beneficiary: z.string().optional(),
  bankName: z.string().optional(),
  bankAddress: z.string().optional(),
  iban: z.string().optional(),
  swift: z.string().optional(),
  instructions: z.string().optional(),
});

/**
 * Дубль валюты в банковских строках ловим уже в форме, до отправки: то же
 * правило проверяет бэкенд (BILLING_SELLER_DUPLICATE_BANK_CURRENCY), но
 * подсветить конкретное поле сразу удобнее для админа, чем ждать ответа
 * сервера. `.passthrough()`: остальные поля формы не валидируются здесь.
 */
export function makeBillingSellerValidationSchema() {
  return z
    .object({
      bankAccounts: z.array(bankAccountSchema).optional(),
    })
    .passthrough()
    .superRefine((values, ctx) => {
      const accounts = values.bankAccounts ?? [];
      const seenCurrencies = new Set<string>();
      accounts.forEach((account, index) => {
        if (!account.currency) return;
        if (seenCurrencies.has(account.currency)) {
          ctx.addIssue({
            code: "custom",
            path: ["bankAccounts", index, "currency"],
            message: "У этой валюты уже есть банковская строка",
          });
        }
        seenCurrencies.add(account.currency);
      });
    });
}
